import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoice,
  BackendMutationDeleteCustomToneOfVoiceArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteCustomToneOfVoice($id: ID!) {
    deleteCustomToneOfVoice(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteCustomToneOfVoiceArgs;
type Result = Pick<BackendCustomToneOfVoice, 'id'>;

export const deleteCustomToneOfVoice = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
